const postModules = import.meta.glob('./**/*.mdx');

function normalizeFrontmatter(module) {
  const frontmatter = module.frontmatter || module.metadata || module.data || module.attributes || {};
  return {
    ...frontmatter,
    tags: Array.isArray(frontmatter.tags) ? frontmatter.tags : [],
    status: frontmatter.draft === true ? 'draft' : (frontmatter.status || 'draft'),
  };
}

export async function loadBlogPost(metadata) {
  const load = metadata && postModules[metadata.source];
  if (!load) throw new Error(`No MDX module found for ${metadata?.slug || 'unknown post'}`);

  const module = await load();
  return {
    ...metadata,
    ...normalizeFrontmatter(module),
    MDXContent: module.default,
  };
}
